// extracted by mini-css-extract-plugin
export default {"input":"AddPost_input__dKaFm","newPost":"AddPost_newPost__eOFEU","image":"AddPost_image__5BtUp"};